import React, {cloneElement, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import CustomTooltip from "./index";

TruncationTooltip.propTypes = {
    title: PropTypes.node,
    children: PropTypes.element.isRequired,
};

// CustomTooltip that only shows up when the child's text is actually
// truncated (text-overflow ellipsis). The child must be a single element
// forwarding its ref to the DOM node carrying the ellipsis.
function TruncationTooltip({title, children, ...props}) {
    const childRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const element = childRef.current;

        if (!element) {
            return;
        }

        const measure = () => setIsTruncated(element.scrollWidth > element.clientWidth);

        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(element);

        return () => observer.disconnect();
    }, [title]);

    return (
        // an empty title disables the MUI tooltip entirely
        <CustomTooltip title={isTruncated ? title : ''} {...props}>
            {cloneElement(children, {ref: childRef})}
        </CustomTooltip>
    );
}

export default TruncationTooltip;
